module.exports = __webpack_public_path__ + "static/media/demo4.b9946de6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/demo4.jpg
// module id = 469
// module chunks = 0